import React from 'react';
import {
  LuTrophy,
  LuCar,
  LuMessageCircle,
  LuUsers,
  LuTarget,
  LuMousePointerClick,
  LuHeart,
  LuRocket,
  LuChevronRight,
  LuCheck,
  LuQuote,
  LuAward,
  LuTrendingUp,
} from 'react-icons/lu';

// Konstanta WhatsApp
const WA_NUMBER = '6282337289588';
const WA_MESSAGE = 'Halo%20SriDesain%2C%20saya%20tertarik%20untuk%20konsultasi%20strategi%20iklan%20seperti%20case%20study%20detailing%20mobil';

function LogoMark({ className = '' }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none">
      <path d="M24 2 L44 12 V24 C44 35 36 42 24 46 C12 42 4 35 4 24 V12 Z" fill="#C9A227" />
      <path
        d="M17 16 h14 a5 5 0 0 1 0 10 h-8 a5 5 0 0 0 0 10 h14"
        stroke="#0F172A"
        strokeWidth="3.2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

const miniStats = [
  { icon: LuMessageCircle, value: '753', label: 'Messaging Conversation' },
  { icon: LuUsers, value: '78.370', label: 'People Reached' },
  { icon: LuTarget, value: '2.50%', label: 'CTR (All)' },
  { icon: LuMousePointerClick, value: '5.278', label: 'Total Clicks' },
];

const strategies = [
  {
    title: 'Audience Targeting Spesifik',
    desc: 'Menargetkan audience yang relevan dengan layanan detailing mobil (interest & behavior).',
  },
  {
    title: 'Creative Iklan yang Menarik',
    desc: 'Visual & copy yang powerful untuk meningkatkan engagement dan mendorong chat.',
  },
  {
    title: 'Penempatan & Budget Optimal',
    desc: 'Menggunakan penempatan terbaik dengan budget yang optimal untuk hasil maksimal.',
  },
  {
    title: 'Optimasi Berkelanjutan',
    desc: 'Monitoring performa setiap hari dan melakukan optimasi untuk menurunkan cost per result.',
  },
];

const trustBadges = [
  { icon: LuAward, label: 'Strategi Terbukti', sub: 'Hasil Nyata' },
  { icon: LuTrendingUp, label: 'Banyak Customer', sub: 'Lebih Banyak Omzet' },
];

const chartPoints = '0,58 8,54 16,50 24,46 32,42 40,36 48,32 56,26 64,22 72,17 80,13 88,10 96,6';

const CaseStudySpotlight = () => {
  return (
    <section className="relative overflow-hidden bg-white px-4 py-14 md:px-6 lg:px-10 lg:py-20">
      {/* Ambient glow */}
      <div className="pointer-events-none absolute -top-32 right-1/4 h-[550px] w-[550px] rounded-full bg-amber-100/60 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-72 w-72 rounded-full bg-slate-100/70 blur-3xl" />

      <div className="relative mx-auto max-w-7xl">
        {/* Header row */}
        <div className="flex items-start justify-between gap-4">
          <span className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-[#0F172A]">
            <LuTrophy className="h-3.5 w-3.5" />
            Case Study 3
          </span>
        </div>

        {/* Headline + photo + result card */}
        <div className="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6">
          {/* Headline & campaign card */}
          <div className="lg:col-span-4">
            <h2 className="font-[var(--font-display)] text-2xl font-black uppercase leading-[1.15] tracking-tight text-[#0F172A] sm:text-3xl">
              Winning Campaign yang Menghasilkan{' '}
              <span className="text-amber-500">Ribuan Customer Conversation</span>
            </h2>

            <p className="mt-4 text-sm leading-relaxed text-slate-600">
              Strategi yang tepat, penargetan akurat, dan creative yang kuat menghasilkan campaign
              dengan performa tinggi dan{' '}
              <span className="font-semibold text-amber-600">cost per result yang efisien.</span>
            </p>

            <div className="mt-6 rounded-2xl border border-slate-200 p-4">
              <div className="flex items-start gap-3">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600">
                  <LuCar className="h-5 w-5" />
                </span>
                <div>
                  <p className="text-xs text-slate-500">Campaign</p>
                  <p className="font-[var(--font-display)] text-base font-bold leading-snug text-[#0F172A]">
                    Layanan Detailing Interior Mobil
                  </p>
                  <span className="mt-1.5 inline-block rounded-full bg-blue-100 px-2.5 py-0.5 text-[10px] font-semibold text-blue-700">
                    Jasa Otomotif
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Photo */}
          <div className="relative lg:col-span-4">
            <div className="pointer-events-none absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-amber-100/70 via-orange-50/40 to-transparent blur-2xl" />
            <div className="relative aspect-[4/4.4] w-full overflow-hidden rounded-[2rem]">
              {/* Ganti div ini dengan foto klien Anda yang merayakan hasil */}
              <img
                src="/hero-case3.png"
                alt="Klien merayakan lonjakan customer chat dari campaign iklan"
                className="h-full w-full object-cover"
                style={{
                  maskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 66%, transparent 100%)',
                  WebkitMaskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 66%, transparent 100%)',
                }}
              />
              {/* Gold trend arrow accent - kept small in the corner so it never crosses the subject's face */}
              <svg
                viewBox="0 0 100 100"
                className="pointer-events-none absolute bottom-3 left-3 h-16 w-16 opacity-80"
                fill="none"
              >
                <polyline
                  points="5,85 30,60 50,72 90,15"
                  stroke="#C9A227"
                  strokeWidth="7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polygon points="90,15 68,24 78,44" fill="#C9A227" />
              </svg>
            </div>

            {/* New customer chat bubble */}
            <div className="absolute right-2 top-4 flex items-center gap-2 rounded-xl border border-slate-100 bg-white/95 px-3 py-2 shadow-lg shadow-slate-300/40 backdrop-blur-md sm:right-4">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green-500">
                <LuMessageCircle className="h-3.5 w-3.5 text-white" />
              </span>
              <div className="leading-tight">
                <p className="text-[11px] font-bold text-[#0F172A]">New Customer!</p>
                <p className="text-[10px] text-slate-500">753 chat baru</p>
              </div>
            </div>

            {/* Heart count badge */}
            <div className="absolute right-3 top-24 flex items-center gap-1 rounded-full bg-red-500 px-3 py-1.5 text-xs font-bold text-white shadow-lg shadow-red-300/40 sm:right-6">
              <LuHeart className="h-3.5 w-3.5" fill="white" /> 753
            </div>
          </div>

          {/* Result card */}
          <div className="lg:col-span-4">
            <div className="flex h-full flex-col justify-center rounded-2xl bg-gradient-to-br from-[#0F172A] to-[#1E293B] p-6 text-center shadow-xl shadow-slate-300/40">
              <p className="text-xs font-semibold uppercase tracking-wide text-slate-300">
                Hasil Campaign
              </p>
              <p className="mt-1 font-[var(--font-display)] text-5xl font-extrabold text-amber-400">
                753
              </p>
              <p className="mt-1 text-xs font-bold uppercase tracking-wide text-white">
                New Customer Chat
              </p>

              <div className="mt-5 grid grid-cols-2 gap-4 border-t border-white/10 pt-5">
                <div>
                  <p className="text-[10px] uppercase tracking-wide text-slate-400">Cost per Result</p>
                  <p className="mt-1 text-xl font-extrabold text-amber-400">Rp4.065</p>
                  <p className="text-[10px] text-slate-400">/Chat</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-wide text-slate-400">CTR (All)</p>
                  <p className="mt-1 text-xl font-extrabold text-amber-400">2.50%</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mini stat pills */}
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {miniStats.map(({ icon: Icon, value, label }) => (
            <div key={label} className="flex items-center gap-2.5 rounded-xl bg-[#0F172A] px-4 py-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber-400 text-[#0F172A]">
                <Icon className="h-4 w-4" />
              </span>
              <div className="leading-tight">
                <p className="text-sm font-extrabold text-white">{value}</p>
                <p className="text-[10px] text-slate-400">{label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Strategy + dashboard */}
        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* Strategy card */}
          <div className="rounded-2xl bg-gradient-to-br from-[#0F172A] to-[#1E293B] p-5">
            <span className="inline-block rounded-full bg-amber-400 px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide text-[#0F172A]">
              Strategi yang Digunakan
            </span>
            <div className="mt-4 space-y-4">
              {strategies.map(({ title, desc }) => (
                <div key={title} className="flex items-start gap-3 border-b border-white/10 pb-4 last:border-0 last:pb-0">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-400">
                    <LuCheck className="h-3 w-3 text-[#0F172A]" strokeWidth={3} />
                  </span>
                  <div>
                    <p className="text-sm font-bold text-white">{title}</p>
                    <p className="mt-0.5 text-xs leading-relaxed text-slate-300">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dashboard card */}
          <div>
            <span className="inline-block rounded-full bg-amber-400 px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide text-[#0F172A]">
              Performance Dashboard
            </span>

            <div className="mt-4 rounded-2xl border border-slate-200 p-4 shadow-sm shadow-slate-100">
              {/* Ad row */}
              <div className="flex items-center gap-3 border-b border-slate-100 pb-3">
                  <img 
                        src="/campaigns/detailing.png" 
                        alt="Layanan Detailing Interior Mobil"
                        className="h-10 w-10 shrink-0 rounded-md object-cover"
                    />
                <div className="min-w-0 flex-1">
                  <p className="truncate text-xs font-semibold text-[#0F172A]">
                    Layanan Detailing Interior Mobil
                  </p>
                  <span className="mt-0.5 inline-block rounded-full bg-blue-100 px-2 py-0.5 text-[9px] font-semibold text-blue-700">
                    Jasa Otomotif
                  </span>
                </div>
                <div className="text-right">
                  <p className="text-sm font-extrabold text-[#0F172A]">753</p>
                  <p className="text-[9px] text-slate-400">Results</p>
                </div>
              </div>

              <div className="mt-3 grid grid-cols-3 gap-2 text-center text-[10px] text-slate-500">
                <div>
                  <p className="font-bold text-[#0F172A]">211,154</p>
                  Impressions
                </div>
                <div>
                  <p className="font-bold text-[#0F172A]">78,370</p>
                  Reach
                </div>
                <div>
                  <p className="font-bold text-[#0F172A]">Rp4,065</p>
                  Cost/Result
                </div>
              </div>

              {/* Chart */}
              <div className="mt-4 border-t border-slate-100 pt-4">
                <p className="text-[11px] font-bold uppercase tracking-wide text-slate-500">
                  Trend Performa (30 Hari)
                </p>
                <svg viewBox="0 0 100 65" className="mt-2 h-24 w-full" preserveAspectRatio="none">
                  <polyline points={chartPoints} fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <div className="mt-2 grid grid-cols-2 gap-3">
                  <div className="rounded-lg bg-slate-50 px-3 py-2">
                    <p className="text-[10px] text-slate-500">Total Chat</p>
                    <p className="text-base font-extrabold text-[#0F172A]">753</p>
                    <p className="text-[10px] font-semibold text-green-600">+156% vs 30 hari lalu</p>
                  </div>
                  <div className="rounded-lg bg-slate-50 px-3 py-2">
                    <p className="text-[10px] text-slate-500">Cost per Chat</p>
                    <p className="text-base font-extrabold text-[#0F172A]">Rp4.065</p>
                    <p className="text-[10px] font-semibold text-green-600">-32% vs 30 hari lalu</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial + trust badges */}
        <div className="mt-8 flex flex-col items-start justify-between gap-6 rounded-2xl border border-slate-200 p-5 sm:flex-row sm:items-center">
          <div className="flex items-start gap-3">
            <LuQuote className="h-6 w-6 shrink-0 text-amber-400" />
            <div>
              <p className="text-sm leading-relaxed text-slate-700">
                Sejak iklan dikelola SriDesain, jumlah chat masuk{' '}
                <span className="font-semibold text-[#0F172A]">meningkat tajam</span> dengan biaya
                yang masih sangat terkontrol! Hasilnya jauh lebih baik dari sebelumnya!
              </p>
              <div className="mt-3 flex items-center gap-2.5">
                 <img 
                        src="/testimoni1.png" 
                        alt="Arif Budiman"
                        className="h-9 w-9 shrink-0 rounded-full object-cover"
                    />
                <div>
                  <p className="text-xs font-bold text-amber-600">Arif Budiman</p>
                  <p className="text-[11px] text-slate-500">Owner - Layanan Detailing Interior Mobil</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex shrink-0 gap-5">
            {trustBadges.map(({ icon: Icon, label, sub }) => (
              <div key={label} className="flex items-center gap-2">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-amber-400 text-amber-500">
                  <Icon className="h-4 w-4" />
                </span>
                <div className="leading-tight">
                  <p className="text-xs font-bold text-[#0F172A]">{label}</p>
                  <p className="text-[10px] text-slate-500">{sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-6 flex flex-col items-center justify-between gap-4 rounded-2xl bg-gradient-to-r from-amber-400 to-amber-500 p-5 shadow-lg shadow-amber-400/30 sm:flex-row">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#0F172A]">
              <LuRocket className="h-5 w-5 text-amber-400" />
            </span>
            <p className="text-sm font-extrabold leading-snug text-[#0F172A] sm:text-base">
              Saatnya Bisnis Anda Dapat Hasil Iklan yang Maksimal!
            </p>
          </div>
            <a
            href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#0F172A] px-6 py-3 text-sm font-bold text-white transition hover:bg-[#1E293B] hover:scale-105 sm:w-auto"
          >
            Konsultasi Strategi Iklan Gratis
            <LuChevronRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudySpotlight;